import { ComponentProps, forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';
import { ForwardedButton } from './Button';

type Props<T extends React.ElementType> = React.PropsWithChildren<{
  as?: T;
  onClick?: () => void;
  disabled?: boolean;
  className?: string;
  inputRef?: React.ForwardedRef<HTMLButtonElement>;
}>;

export function CircleButton<T extends React.ElementType = 'button'>({
  as,
  children,
  className,
  inputRef,
  ...props
}: Props<T> & Omit<React.ComponentPropsWithoutRef<T>, keyof Props<T>>): JSX.Element {
  const Component = as || ForwardedButton;

  const classNames = twMerge('transition rounded-full p-1 hover:bg-zinc-100', className);

  return (
    <Component fill="ghost" className={classNames} ref={inputRef} {...props}>
      {children}
    </Component>
  );
}

export const ForwardedCircleButton = forwardRef<
  HTMLButtonElement,
  ComponentProps<typeof CircleButton>
>((props, ref) => (
  <CircleButton inputRef={ref} {...props}>
    {props.children}
  </CircleButton>
));
